module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./CouponOfListView.js"));
	}, "CouponOfListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CouponOfListView!./src/pages/Learn/CouponOfList/CouponOfListView.js
// module id = 1769
// module chunks = 418